/**
 * English rounding prompts (ADR 0051 part 3). `roundClauses` is a full clause
 * per rounding place (exponent -1..3, see RoundingComparingGenerator.ts's
 * PLACE_EXPONENT), written whole for the same reason PlaceValue's clauses
 * are: Spanish and French's equivalent nouns do not share one gender.
 */
export const roundClauses: Record<number, string> = {
    [-1]: 'to the nearest tenth',
    0: 'to the nearest whole',
    1: 'to the nearest ten',
    2: 'to the nearest hundred',
    3: 'to the nearest thousand',
};

export const roundingPrompts = {
    round: (value: string, clause: string) => `Round ${value} ${clause}.`,
};
